import React,  { useState, useEffect } from "react"
import Layout from "../components/layout"
import MobileLayout from "../components/mobile-layout"
import SEO from "../components/seo"
import Row from 'react-bootstrap/Row'
import Spinner from 'react-bootstrap/Spinner'
import Page404 from '../pages/404';
import Styles from '../pages/blogs.module.scss'

const isBrowser = () => typeof window !== "undefined"
const isMobile = isBrowser() ? (window.innerWidth < 980 ? true : false) :  false

export default function SpecialCourse({ pageContext: { seo_slug } }) {

  const [width, setWidth] = useState(0)
  const [seo_page_detail, setSeoPageDetail] = useState({})
  const [seo_page_fetched, setSeoPageFetched] = useState(false)
  const [https_status, setHttpsStatus] = useState(200)

  useEffect(() => {
    if (isBrowser()) {
      setWidth(window.innerWidth);
      const handleResize = () => setWidth(window.innerWidth)
      window.addEventListener("resize", handleResize);
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }
  }, []);
  useEffect(() => {
    if (!seo_page_fetched) {
      fetchSeoPage()
    }
  }, [])

  async function fetchSeoPage() {
    let seo_data = seo_page_detail, datum
    await fetch(`${process.env.GATSBY_REACT_APP_SEO_PAGE_API}/${seo_slug.slug}.json`).then(response => {
      if (response.status === 403) {
        setHttpsStatus(404);setSeoPageFetched(false)
      }else {
        return response.json();
      }
    }).then(data => {
      if (https_status !== 404) {
        seo_data['data'] = data.data;
        setSeoPageDetail(seo_data)
        setSeoPageFetched(true)
        fetch(`https://z2jtxoy6f7.execute-api.us-east-1.amazonaws.com/default/updateMeetupByCity?find=${seo_slug.slug}&return=all&key=url&type=seo_pages`).then(response => {
          if (response.status === 403) {
            setHttpsStatus(404);setSeoPageFetched(false)
          }else {
            return response.json();
          }
        }).then(data => {
          Object.values(data).map( (page, ind) => {
            if(seo_data['data']){
              datum = seo_data['data']
            }
            Object.assign(page,seo_data);
            setSeoPageDetail(page)
            setSeoPageFetched(true)
          });
        }).catch(error => {setSeoPageDetail([]);setSeoPageFetched(false)});
      }
    }).catch(error => {setSeoPageDetail([]);setSeoPageFetched(false)})
  }

  if (https_status !== 404) {
    if (seo_page_fetched){
      let seo_title = seo_page_detail.seo_title === undefined ? '' : seo_page_detail.seo_title
      if (isMobile || width <= 980) {
        return (
          <MobileLayout>
            <SEO title={seo_title} description={seo_page_detail.seo_description}/>
            <Row className="mx-auto mb-4 mt-3"  style={{maxWidth: isBrowser() ? window.innerWidth < window.innerHeight ? '80%' : '90%' : '80%'}}>
              <div className="w-100">
                <h1 className="text-center" style={{fontSize: '18px'}}>{seo_page_detail.page_title}</h1>
                <div className={`${Styles.backend_images} ${Styles.backend_data}`} dangerouslySetInnerHTML={{ __html: seo_page_detail.data}} />
              </div>
            </Row>
          </MobileLayout>
        );
      } else {
        return (
          <Layout>
            <SEO title={seo_title} description={seo_page_detail.seo_description}/>
            <Row className="mx-auto my-4"  style={{boxShadow: '0 0px 5px 2px rgba(0, 0, 0, 0.1)', borderRadius: '15px', maxWidth: '90%'}}>
              <div className="py-3" style={{padding: '0 5rem'}}>
                <h1 className="text-center" style={{fontSize: '18px'}}>{seo_page_detail.page_title}</h1>
                <div className={`${Styles.backend_images} ${Styles.backend_data}`} dangerouslySetInnerHTML={{ __html: seo_page_detail.data}} />
              </div>
            </Row>
          </Layout>
        )
      }
    } else {
      return (<div className="float-left w-100 py-5"><div className={`d-flex align-items-center`} style={{position: 'relative', left: '40%'}}><Spinner animation="grow" size="lg" className={`mr-2`} role="status"/>Loading...</div></div>);
    }
  } else {
    return <Page404 />;
  }
}
